export const cleanPageUrl = (url: string): string => {
    try {
        const parsedUrl = new URL(url);
        return `${parsedUrl.origin}${parsedUrl.pathname}`;
    } catch {
        return url.split(/[?#]/)[0];
    }
};

export const getCurrentPageUrl = (): string => cleanPageUrl(window.location.href);
